<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area tech" ref="visualRef">
      <div class="tit_area">
        <div class="sub_tit">PC 사업</div>
        <div class="sub_txt">빠르고, 쉽게 새로운 건설 패러다임을 만듭니다.</div>
      </div>
    </div>
    <!--// sub title -->

    <t-toggle @change="onChangeTab" :activateIndex="activateTabIdx">
      <div :class="['tab_area', { fixed: isFixed }]">
        <div class="tab_item">
          <t-toggle-button
            v-for="(item, idx) in $t('header[1].subs[0].tabs')"
            :hash="`#tab${idx + 1}`"
            :key="`ttoggle-button--$${idx}`"
            href="#"
            tag="a"
            onClass="active"
            >{{ item.name }}</t-toggle-button
          >
        </div>
      </div>
      <!-- sub contents -->
      <div class="sub_contents">
        <!-- PC공법 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <p class="tit_tip gs_y0">Precast Concrete</p>
          <h3 class="gs_y0">PC 공법이란?</h3>
          <div class="sub_cont_txt gs_y0">
            PC (Precast Concrete) 공법은 “사전에 제작한 콘크리트”라는 의미로
            공장에서 기둥, 보, 슬라브, 벽체와 같은 구조물을 형틀에 맞추어 제작한
            후 현장으로 운반 및 조립하는 첨단 건설 공법
            <img
              class="mgt30"
              :src="`${resources}img/img_tech01_1.jpg`"
              alt=""
            />
          </div>

          <h3>PC 공법 장점</h3>
          <ul class="tech_item gs_st0">
            <li class="ico01">
              <p class="tech_item_tit">대량 생산</p>
              <p class="tech_item_txt">동일 제품 단기간 대량 및 맞춤 생산</p>
            </li>
            <li class="ico02">
              <p class="tech_item_tit">고품질로 고객만족</p>
              <p class="tech_item_txt">품질을 균등화하여 고객 만족 실현</p>
            </li>
            <li class="ico03">
              <p class="tech_item_tit">비용 절감</p>
              <p class="tech_item_txt">일반 공법 대비 2~5% 비용 절감</p>
            </li>
            <li class="ico04">
              <p class="tech_item_tit">재해 발생 최소화</p>
              <p class="tech_item_txt">
                현장 투입인력 저감으로 재해 발생 최소화
              </p>
            </li>
            <li class="ico05">
              <p class="tech_item_tit">환경친화적</p>
              <p class="tech_item_txt">
                공장 사전 제작으로 현장 폐기물, 분진, 소음 최소화
              </p>
            </li>
            <li class="ico06">
              <p class="tech_item_tit">공사기간 단축</p>
              <p class="tech_item_txt">
                현장 마감 작업 감소로 공사기간 30% <br />단축
              </p>
            </li>
          </ul>

          <h3 class="pdb30">PC 공법 프로세스</h3>

          <div
            ref="processPcTabRef"
            class="tab2_area"
            v-toggle="{
              target: 'processPcTabRef',
              selector: 'ul > li > a',
              dataType: Boolean(),
            }"
            @onChange="changeProcessPcTab"
          >
            <ul class="tab_item2">
              <li :class="{ active: processPcTabActArr[0] }">
                <a href="#none">PC 생산</a>
              </li>
              <li :class="{ active: processPcTabActArr[1] }">
                <a href="#none">PC 시공</a>
              </li>
            </ul>
            <div :class="['conbox2', { active: processPcTabActArr[0] }]">
              <video
                class="con_video"
                autoplay=""
                loop=""
                muted=""
                playsinline=""
                v-if="video[0]"
              >
                <source
                  :src="`${resources}file/pcc_video_01.mp4`"
                  type="video/mp4"
                />
              </video>
              <img
                :src="`${resources}img/img_tech_pc01-1.jpg`"
                alt="pc생산 진행 순서. STEP 01:최적설계 및 엔지니어링 (VE), STEP 02:몰드 제작, STEP 03:철근조립, STEP 04:선행 생산, STEP 05:생산부재 야적장 이동 , STEP 06:부재운송 (시공현장)"
              />
            </div>
            <div :class="['conbox2', { active: processPcTabActArr[1] }]">
              <video
                class="con_video"
                autoplay=""
                loop=""
                muted=""
                playsinline=""
                v-if="video[1]"
              >
                <source
                  :src="`${resources}file/pcc_video_02.mp4`"
                  type="video/mp4"
                />
              </video>
              <img
                :src="`${resources}img/img_tech_pc02.jpg`"
                alt="pc시공 순서. STEP 01:먹매김 및 기초 앙카 시공, STEP 02:기둥 조립, STEP 03:보 조립, STEP 04:슬래브 조립, STEP 05:철근 배근 및 타평 콘크리트 타설, STEP 06:시공 완료"
              />
            </div>
          </div>
        </t-toggle-content>
        <!--// PC공법 -->

        <!-- HCS공법 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <p class="tit_tip gs_y1">Hollow Core Slab</p>
          <h3 class="gs_y1">HCS 공법이란?</h3>
          <div class="sub_cont_txt gs_y1">
            HCS 공법은 PC 공법의 일부로 “부재 내부의 속을 비워 경량화한 PC
            슬래브”로 자동화 생산 시스템으로 대량 생산 가능한 최첨단 건설 공법
            <img class="mgt30" :src="`${resources}img/img_tech01.jpg`" alt="" />
          </div>

          <h3>HCS 공법 장점</h3>
          <ul class="tech_item gs_st1">
            <li class="ico07">
              <p class="tech_item_tit">자동화 생산 시스템</p>
              <p class="tech_item_txt">자동화로 높은 생산성과 효율성 향상</p>
            </li>
            <li class="ico08">
              <p class="tech_item_tit">경제성 향상</p>
              <p class="tech_item_txt">부재의 50%가 빈 공간으로 경제성 향상</p>
            </li>
            <li class="ico09">
              <p class="tech_item_tit">구조적 효율성</p>
              <p class="tech_item_txt">장경간 설계가 가능하여 구조적 효율성</p>
            </li>
          </ul>
          <div class="dot_star right">
            프리텐션(Pre-tension): 콘크리트를 부어 넣기 전에 PC 강재에
            프리스트레스를 주는 방식
          </div>

          <h3 class="pdb30">HCS 공법 자동화 라인</h3>
          <img
            :src="`${resources}img/img_tech_bg.png`"
            alt="핀란드 ELEMATIC HCS 시스템 설치"
          />

          <div class="tech_container">
            <div class="tech_area2">
              <ul class="tech_item2">
                <li>
                  <div class="tech_tit">
                    <em><span>01</span><br />Preparer</em>준비설비
                  </div>
                  <img :src="`${resources}img/img_tech_st01.png`" alt="" />
                  <div class="tech_txt">
                    생산 시작 전 생산 라인 청소 및<br />강연선을 배열하는 설비
                  </div>
                </li>
                <li>
                  <div class="tech_tit">
                    <em
                      ><span>02</span><br />
                      Concrete Shuttle</em
                    >운송설비
                  </div>
                  <img :src="`${resources}img/img_tech_st02.png`" alt="" />
                  <div class="tech_txt">
                    배합된 콘크리트를<br />생산 설비로 운송하는 설비
                  </div>
                </li>
                <li>
                  <div class="tech_tit">
                    <em><span>03</span><br />Extruder</em>생산설비
                  </div>
                  <img :src="`${resources}img/img_tech_st03.png`" alt="" />
                  <div class="tech_txt">HCS를 생산하는 설비</div>
                </li>
                <li>
                  <div class="tech_tit">
                    <em><span>04</span><br />Cutting Saw</em>절단설비
                  </div>
                  <img :src="`${resources}img/img_tech_st04.png`" alt="" />
                  <div class="tech_txt">
                    생산된 HCS를<br />자동으로 절단하는 설비
                  </div>
                </li>
                <li>
                  <div class="tech_tit">
                    <em><span>05</span><br />Batch&Mixing Plant</em>콘크리트
                    배합설비
                  </div>
                  <img :src="`${resources}img/img_tech_st05.png`" alt="" />
                  <div class="tech_txt">콘크리트 배합 및 제조 설비</div>
                </li>
                <li>
                  <div class="tech_tit">
                    <em><span>06</span><br />Storage System</em>야적설비
                  </div>
                  <img :src="`${resources}img/img_tech_st06.png`" alt="" />
                  <div class="tech_txt">
                    자동 평형기구가 적용된<br />초고속 야적설비
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <h3>HCS 생산 프로세스</h3>
          <video
            class="con_video mgt40"
            autoplay=""
            loop=""
            muted=""
            playsinline=""
            v-if="video[2]"
          >
            <source
              :src="`${resources}file/pcc_video_03.mp4`"
              type="video/mp4"
            />
          </video>
          <div class="img_wrap mgt40">
            <img
              :src="`${resources}img/img_hcs01-2.png`"
              alt="HCS 생산 진행 순서. STEP 01최적 설계 및 엔지니어링(VE),STEP 02선행 생산, STEP 03생산 부재 야적장 이동,STEP  04부재 운송(시공현장)"
            />
          </div>
        </t-toggle-content>
        <!--// HCS공법 -->

        <!-- 공장소개 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <p class="tit_tip gs_y2" id="factory1">Asan Factory</p>
          <h3 class="pdb30 gs_y2">아산공장</h3>
          <div class="sub_cont_txt gs_y2">
            <img :src="`${resources}img/img_factory01.jpg`" alt="" />
          </div>
          <h3 class="pdb30">
            최첨단 자동화 생산설비를 갖춘 아시아 최대 규모 PC공장
          </h3>
          <div class="tbl_ty05">
            <table>
              <caption>
                최첨단 자동화 생산설비를 갖춘 아시아 최대 규모 PC공장 :
                설립년도, 연간 생산능력, 위치, 공장면적, 대표전화, 팩스로
                이루어진 표
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="col">설립년도</th>
                  <td>1996</td>
                  <th scope="col">연간 생산능력</th>
                  <td>240,000 m<sup>3</sup></td>
                </tr>
                <tr>
                  <th scope="col">위치</th>
                  <td>
                    <a
                      class="btn_map"
                      href="http://naver.me/FrKhHkmu"
                      target="_blank"
                      rel="noreferrer noopener"
                      >충청남도 아산시 영인면 토정샘로 66</a
                    >
                  </td>
                  <th scope="col">공장면적</th>
                  <td>180,387 m<sup>2</sup> (축구장의 25배/54,567평)</td>
                </tr>
                <tr>
                  <th scope="col">대표전화</th>
                  <td>041-544-0155</td>
                  <th scope="col">팩스</th>
                  <td>041-541-5369</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="tit_h4">주요시설</div>
          <ul class="view_list li4 gs_y2">
            <li>
              <img :src="`${resources}img/img_factory_s_01.jpg`" alt="" />
              <div class="tit">야적장</div>
              <div class="txt">
                <ul>
                  <li>직선 형태 야적 공간을 형성하여 효율적 야적 관리 가능</li>
                </ul>
              </div>
            </li>
            <li>
              <img :src="`${resources}img/img_factory_s_02.jpg`" alt="" />
              <div class="tit">HCS 자동화 라인</div>
              <div class="txt">
                <ul>
                  <li>첨단 자동생산라인 구축으로 우수한 품질 확보</li>
                </ul>
              </div>
            </li>
            <li>
              <img :src="`${resources}img/img_factory_s_03.jpg`" alt="" />
              <div class="tit">철근 가공장</div>
              <div class="txt">
                <ul>
                  <li>
                    실내 철근 관리, 보관, 가공, 조립 등 <br />대량생산 시스템
                    구축
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <img :src="`${resources}img/img_factory_s_04.jpg`" alt="" />
              <div class="tit">생산동</div>
              <div class="txt">
                <ul>
                  <li>환경적 영향을 받지 않는 실내 생산시설 보유</li>
                </ul>
              </div>
            </li>
          </ul>

          <p class="tit_tip mgt100" id="factory2">Eumseong Factory</p>
          <h3 class="pdb30">음성공장</h3>
          <div class="sub_cont_txt">
            <img :src="`${resources}img/img_factory03.jpg`" alt="" />
          </div>
          <h3 class="pdb30">
            전국 PC 제조 운송 물류거점 및 일등 품질의 최상급 제품 생산
          </h3>
          <div class="tbl_ty05">
            <table>
              <caption>
                전국 PC 제조 운송 물류거점 및 일등 품질의 최상급 제품 생산 :
                설립년도, 연간 생산능력, 위치, 공장면적, 대표전화, 팩스로
                이루어진 표
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="col">설립년도</th>
                  <td>2015</td>
                  <th scope="col">연간 생산능력</th>
                  <td>120,000 m<sup>3</sup></td>
                </tr>
                <tr>
                  <th scope="col">위치</th>
                  <td>
                    <a
                      class="btn_map"
                      href="http://naver.me/5xKzHvKT"
                      target="_blank"
                      rel="noreferrer noopener"
                      >충청북도 음성군 감곡면 가곡로 335</a
                    >
                  </td>
                  <th scope="col">공장면적</th>
                  <td>166,456 m<sup>2</sup> (축구장의 24배/50,353평)</td>
                </tr>
                <tr>
                  <th scope="col">대표전화</th>
                  <td>043-927-0790</td>
                  <th scope="col">팩스</th>
                  <td>043-901-0023</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="tit_h4">주요시설</div>
          <ul class="view_list li4">
            <li>
              <img :src="`${resources}img/img_factory_s_05.jpg`" alt="" />
              <div class="tit">야적장</div>
              <div class="txt">
                <ul>
                  <li>충분한 야적공간으로 대량생산 가능</li>
                </ul>
              </div>
            </li>
            <li>
              <img :src="`${resources}img/img_factory_s_06.jpg`" alt="" />
              <div class="tit">생산동</div>
              <div class="txt">
                <ul>
                  <li>환경적 영향을 받지 않는 실내 생산시설 보유</li>
                </ul>
              </div>
            </li>
            <li>
              <img :src="`${resources}img/img_factory_s_07.jpg`" alt="" />
              <div class="tit">철근 가공장</div>
              <div class="txt">
                <ul>
                  <li>
                    실내 철근 관리, 보관, 가공, 조립 등 <br />대량생산 시스템
                    구축
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <img :src="`${resources}img/img_factory_s_08.jpg`" alt="" />
              <div class="tit">배치플랜트</div>
              <div class="txt">
                <ul>
                  <li>트윈 믹서 탑재 설비로 대량 콘크리트 생산 가능</li>
                </ul>
              </div>
            </li>
          </ul>
        </t-toggle-content>
        <!--// 공장소개 -->

        <!-- 시공사례 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <div
            ref="buildCatgRef"
            class="tab3_area"
            v-toggle="{
              target: 'buildCatgRef',
              selector: 'ul > li > a',
              onlyOpen: true,
              dataType: Boolean(),
            }"
            @onChange="changeBuildCatg"
          >
            <ul class="tab_item3">
              <li :class="{ active: buildCatgActArr[0] }">
                <a href="#" title="대형 건물 · 쇼핑센터 · 물류센터 · 공장"
                  >대형 건물 &middot; 쇼핑센터 <br />물류센터 &middot; 공장</a
                >
              </li>
              <li :class="{ active: buildCatgActArr[1] }">
                <a href="#" title="종합운동장 및 대형 경기장"
                  >종합운동장 및 대형 경기장</a
                >
              </li>
              <li :class="{ active: buildCatgActArr[2] }">
                <a href="#" title="아파트 구조물">아파트 구조물</a>
              </li>
              <li :class="{ active: buildCatgActArr[3] }">
                <a href="#" title="벽식PC주택">벽식PC주택</a>
              </li>
            </ul>
            <!-- 대형 건물 · 쇼핑센터 · 물류센터 · 공장 -->
            <div
              id="feature"
              :class="['conbox3', { active: buildCatgActArr[0] }]"
            >
              <div class="tech_slide">
                <div class="techSlide1 tech_slide01" ref="techSlide1">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_05.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_06.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_07.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_08.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_09.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
                <div class="tech-navi">
                  <div class="tech-button-prev"></div>
                  <div class="tech-button-next"></div>
                </div>
                <div class="techSlide2 tech_slide02" ref="techSlide2">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s05.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s06.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s07.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s08.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide01_s09.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex_box mgt60">
                <h3>
                  대형 건물 &middot; 쇼핑센터 &middot; 물류센터 &middot; 공장
                </h3>
                <div class="selectbox3 vselect ty_wid">
                  <v-select
                    v-model="selectYear[0]"
                    :options="selectOptions[0]"
                    :searchable="false"
                    placeholder="년도"
                    :class="{ active: selectYear[0] !== null }"
                  >
                  </v-select>
                </div>
              </div>

              <div class="tbl_ty01 bod align_td_cnt">
                <table>
                  <caption>
                    대형 건물 · 쇼핑센터 · 물류센터 · 공장
                  </caption>
                  <colgroup>
                    <col style="width: 33.33%" />
                    <col style="width: 33.33%" />
                    <col style="width: auto" />
                  </colgroup>

                  <!-- 2023년 -->
                  <tbody
                    v-if="selectYear[0] === 2023 || selectYear[0] === null"
                  >
                    <tr>
                      <td>한양산업개발</td>
                      <td>이천 행죽리 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼일C&S</td>
                      <td>여주 점봉동 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>강산건설</td>
                      <td>다대리 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                  </tbody>

                  <!-- 2022년 -->
                  <tbody
                    v-if="selectYear[0] === 2022 || selectYear[0] === null"
                  >
                    <tr>
                      <td>한양산업개발</td>
                      <td>마스턴 로지스포인트 호법A 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>평택 고덕신도시 지식산업센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>창원 진해구 용원동 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>이수건설</td>
                      <td>여주 신근리 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>새천년종합건설주식회사</td>
                      <td>평택 후사리 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>강산건설</td>
                      <td>양평리 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>HDC현대산업개발</td>
                      <td>안성 가유지구 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2021 || selectYear[0] === null"
                  >
                    <!-- 2021년 -->
                    <tr>
                      <td>KCC건설</td>
                      <td>용인남사 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>KCC건설</td>
                      <td>인천항동7가 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>KCC건설</td>
                      <td>인천원창2 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>꺄뮤이엔씨</td>
                      <td>인천 검단 물류센터 HCS</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>인천오류동 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>인천 남동국가산업단지 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한화건설</td>
                      <td>고양향동 5BL 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                  </tbody>
                  <!-- //2021년 -->

                  <tbody
                    v-if="selectYear[0] === 2020 || selectYear[0] === null"
                  >
                    <!-- 2020년 -->
                    <tr>
                      <td>IS동서</td>
                      <td>양지C구역 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>KCC건설</td>
                      <td>인천서구원창동 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>아산8라인 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>탕정제2지방산업단지 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼호</td>
                      <td>인천항동7가 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>시엘에스이엔지</td>
                      <td>과천약수교회 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>우림콘크리트</td>
                      <td>안산스마트로지스퀘어 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>창성건설</td>
                      <td>평택팸스캠프 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>케이세웅</td>
                      <td>신세계광주오포 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>양지물류2차 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>광주도척 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>이천소고리 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>이천안평리 물류창고</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>현대ENG</td>
                      <td>하남미사 공동구 덮개 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2020년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2019 || selectYear[0] === null"
                  >
                    <!-- 2019년 -->
                    <tr>
                      <td>KCC건설</td>
                      <td>안성원곡 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>인천남동오션뷰 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>기창건설</td>
                      <td>SK기흥ICT밸리 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>까뮤이앤씨</td>
                      <td>시흥배곧 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>까뮤이앤씨</td>
                      <td>한라화성동탄C 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>동성건설</td>
                      <td>부천신중동지식산업센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>평택FAB2기덮개 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>재성종합건설</td>
                      <td>천안모전리물류창고 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>지산</td>
                      <td>용인남사 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한양산업개발</td>
                      <td>인천항동TJ물류 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2019년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2018 || selectYear[0] === null"
                  >
                    <!-- 2018년 -->
                    <tr>
                      <td>KCC건설</td>
                      <td>이천F&F 물류창고 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>KCC건설</td>
                      <td>이천마장 물류창고 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>KCC건설</td>
                      <td>안성죽산물류창고 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>동성건설</td>
                      <td>가좌G타워지식산업센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성ENG</td>
                      <td>평택2기 정수장 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>화성 E-PJT 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>평택 EUV 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>평택 EUV2차</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>평택 FAB2기</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>선경이엔씨</td>
                      <td>휴매드 시화MTV 물류센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>신흥산업</td>
                      <td>동진F&C지식산업센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>우림콘크리트</td>
                      <td>하남미사다인지식산업센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>제이앤에스테크</td>
                      <td>부산산성터널풍도 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>한라</td>
                      <td>삼성전자평택주차빌딩 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2018년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2017 || selectYear[0] === null"
                  >
                    <!-- 2017년 -->
                    <tr>
                      <td>GS건설</td>
                      <td>LGD파주냉각탑증축 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>KD건설</td>
                      <td>당목리 물류센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>공명이엠씨</td>
                      <td>삼성화재아산사옥장비반입구 지상구조</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>공명이엠씨</td>
                      <td>삼성화재 아산사옥 장비반입구</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>금강종합건설</td>
                      <td>인천부평테크시티 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>대림산업</td>
                      <td>고양로지스틱스 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>동성건설</td>
                      <td>대구성서드림타운지식산업센터 지상</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼표피앤씨</td>
                      <td>SK하이닉스 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>서브원</td>
                      <td>판토스시화물류센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>선경이앤씨</td>
                      <td>팅크웨어 HCS 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>태명실업</td>
                      <td>서안성물류센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>티에프이엔씨</td>
                      <td>포천열병합발전소 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>중이온가속기 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>서울복합발전소지하화공사 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>포스코대우</td>
                      <td>평창미디어숙소 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>힐스테이트판교모비우스연결브릿지 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2017년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2016 || selectYear[0] === null"
                  >
                    <!-- 2016년 -->
                    <tr>
                      <td>CJ건설</td>
                      <td>광주 메가 허브 터미널</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>부천오정물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>소백종합건설</td>
                      <td>부천 태영전열 공장</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>소백종합건설</td>
                      <td>부천 CK덴탈 공장</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>소백종합건설</td>
                      <td>부천 남양인쇄 공장</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>우일</td>
                      <td>남극세종기지 하계연구동</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>현대자동차 연수원 천안</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2016년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2015 || selectYear[0] === null"
                  >
                    <!-- 2015년 -->
                    <tr>
                      <td>삼성물산</td>
                      <td>화성DSR C동 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>삼성엔지니어링</td>
                      <td>평택고덕 그린동 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2015년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2014 || selectYear[0] === null"
                  >
                    <!-- 2014년 -->
                    <tr>
                      <td>SK건설</td>
                      <td>이천 하이닉스 반도체 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2014년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2011 || selectYear[0] === null"
                  >
                    <!-- 2011년 -->
                    <tr>
                      <td>LS산전</td>
                      <td>유유물류센터 지상구조물</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>동부건설</td>
                      <td>안성농식품 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>선경이엔씨</td>
                      <td>오크라인 이천물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2011년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2010 || selectYear[0] === null"
                  >
                    <!-- 2010년 -->
                    <tr>
                      <td>삼성물산</td>
                      <td>화성 반도체 공장</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>선경이엔씨</td>
                      <td>덕평물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2010년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2009 || selectYear[0] === null"
                  >
                    <!-- 2009년 -->
                    <tr>
                      <td>동원시스템즈</td>
                      <td>시화물류센타</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>선경이엔씨</td>
                      <td>일미물류 이천 물류센터</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>포유이엔지</td>
                      <td>홍익대 MHS보</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>고양 체육관</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>화인종합건설</td>
                      <td>안성 축산종합타운 신축공사</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2009년 -->
                  </tbody>
                  <tbody
                    v-if="selectYear[0] === 2008 || selectYear[0] === null"
                  >
                    <!-- 2008년 -->
                    <tr>
                      <td>SK건설</td>
                      <td>부산오륙도중학교 지상층RC,PC</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>용인동백아파트형공장</td>
                      <td>지상구조물</td>
                    </tr>
                    <tr>
                      <td>엠코</td>
                      <td>고양터미널</td>
                      <td>지상구조물</td>
                    </tr>
                    <!-- //2008년 -->
                  </tbody>
                </table>
              </div>
            </div>
            <!-- 대형 건물 · 쇼핑센터 · 물류센터 · 공장 -->
            <!-- 종합운동장 및 대형 경기장 -->
            <div :class="['conbox3', { active: buildCatgActArr[1] }]">
              <div class="tech_slide">
                <div class="techSlide3 tech_slide01" ref="techSlide3">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
                <div class="tech-navi">
                  <div class="tech-button-prev"></div>
                  <div class="tech-button-next"></div>
                </div>
                <div class="techSlide4 tech_slide02" ref="techSlide4">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_s01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_s02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_s03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide02_s04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex_box mgt60">
                <h3>종합운동장 및 대형 경기장</h3>
                <div class="selectbox3 vselect ty_wid">
                  <v-select
                    v-model="selectYear[1]"
                    :options="selectOptions[1]"
                    :searchable="false"
                    placeholder="년도"
                    :class="{ active: selectYear[1] !== null }"
                  >
                  </v-select>
                </div>
              </div>
              <!-- select 선택 시 해당 년도별 나오게 스크립트 부탁드립니다. -->
              <div class="tbl_ty01 bod align_td_cnt">
                <table>
                  <caption>
                    종합운동장 및 대형 경기장
                  </caption>
                  <colgroup>
                    <col style="width: 33.33%" />
                    <col style="width: 33.33%" />
                    <col style="width: auto" />
                  </colgroup>
                  <!-- 2014년 -->
                  <tbody
                    v-if="selectYear[1] === 2014 || selectYear[1] === null"
                  >
                    <tr>
                      <td>진흥기업</td>
                      <td>광주 다목적 경기장</td>
                      <td>경기장</td>
                    </tr>
                  </tbody>
                  <!-- //2014년 -->
                  <!-- 2013년 -->
                  <tbody
                    v-if="selectYear[1] === 2013 || selectYear[1] === null"
                  >
                    <tr>
                      <td>동부건설</td>
                      <td>수원야구장증축 경기장</td>
                      <td>경기장</td>
                    </tr>
                  </tbody>
                  <!-- //2013년 -->
                  <!-- 2012년 -->
                  <tbody
                    v-if="selectYear[1] === 2012 || selectYear[1] === null"
                  >
                    <tr>
                      <td>GS건설</td>
                      <td>송림경기장 경기장</td>
                      <td>경기장</td>
                    </tr>
                  </tbody>
                  <!-- //2012년 -->
                  <!-- 2009년 -->
                  <tbody
                    v-if="selectYear[1] === 2009 || selectYear[1] === null"
                  >
                    <tr>
                      <td>SK건설</td>
                      <td>F1경주장</td>
                      <td>경기장</td>
                    </tr>
                  </tbody>
                  <!-- //2009년 -->
                </table>
              </div>
            </div>
            <!-- 종합운동장 및 대형 경기장 -->
            <!-- 아파트 구조물 -->
            <div :class="['conbox3', { active: buildCatgActArr[2] }]">
              <div class="tech_slide">
                <div class="techSlide5 tech_slide01" ref="techSlide5">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
                <div class="tech-navi">
                  <div class="tech-button-prev"></div>
                  <div class="tech-button-next"></div>
                </div>
                <div class="techSlide6 tech_slide02" ref="techSlide6">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_s01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_s02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_s03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide03_s04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex_box mgt60">
                <h3>아파트 구조물</h3>
                <div class="selectbox3 vselect ty_wid">
                  <v-select
                    v-model="selectYear[2]"
                    :options="selectOptions[2]"
                    :searchable="false"
                    placeholder="년도"
                    :class="{ active: selectYear[2] !== null }"
                  >
                  </v-select>
                </div>
              </div>
              <!-- select 선택 시 해당 년도별 나오게 스크립트 부탁드립니다. -->
              <div class="tbl_ty01 bod align_td_cnt">
                <table>
                  <caption>
                    아파트 구조물
                  </caption>
                  <colgroup>
                    <col style="width: 33.33%" />
                    <col style="width: 33.33%" />
                    <col style="width: auto" />
                  </colgroup>

                  <!-- 2023년 -->
                  <tbody
                    v-if="selectYear[2] === 2023 || selectYear[2] === null"
                  >
                    <tr>
                      <td>우미건설</td>
                      <td>우미오산세교2차</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>천안일봉1BL</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>부산에코델타</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>음성성본</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>광주운암3</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>포스코이앤씨</td>
                      <td>안양1동진흥</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>이천중리1차</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>인천검단5차</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>광주마륵공원</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>파주금촌2</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>라인건설</td>
                      <td>오산세교2지구A3BL</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>천안일봉2BL</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>

                  <!-- 2022년 -->
                  <tbody
                    v-if="selectYear[2] === 2022 || selectYear[2] === null"
                  >
                    <tr>
                      <td>호반건설</td>
                      <td>대전 도마변동 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>오포자이오브제 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반산업</td>
                      <td>남원주역세권 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미개발</td>
                      <td>진주역세권 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>평택고덕 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>나주역자이리버파크 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>부산에코텔타 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>인천영종하늘 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>화성비봉 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>당진수청 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>봉담자이라젠느 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금강주택</td>
                      <td>인천검단 주상복합 금강펜테리움</td>
                      <td>옥상조형물</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>오산세교 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반산업</td>
                      <td>파주운정3 A2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반산업</td>
                      <td>파주운정3 A39 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대성베르힐건설</td>
                      <td>인천영종하늘도시 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- 2021년 -->
                  <tbody
                    v-if="selectYear[2] === 2021 || selectYear[2] === null"
                  >
                    <tr>
                      <td>GS건설</td>
                      <td>화성봉담 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>평택지제 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>가평자이 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>강릉자이 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>평택고덕A54 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>파주운정2차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>대구배나무골 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>인천검단 5차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>코오롱글로벌</td>
                      <td>부산사직 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>신동아건설</td>
                      <td>세종 6-3 H3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>세종 6-3 H2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>포천 구읍리 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>강서 신혼희망타운 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>인천검단 3차 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>경산하양 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                  </tbody>
                  <!-- //2021년 -->
                  <!-- 2020년 -->
                  <tbody
                    v-if="selectYear[2] === 2020 || selectYear[2] === null"
                  >
                    <tr>
                      <td>금호건설</td>
                      <td>양원지구 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>청주율량 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>전주효자 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>부산기장 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>광주우산 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>수원팔달8 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>한신공영</td>
                      <td>아산탕정2-A15BL 지하주차장,아파트</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>고양덕은A6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>한신공영</td>
                      <td>인천검단AB5블럭 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>군산나운2재건축 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>대구다사역어울림 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>녹번역 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>구리수택 옥상조형물</td>
                      <td>오픈발코니</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>보라매자이 오픈발코니</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2020년 -->
                  <!-- 2019년 -->
                  <tbody
                    v-if="selectYear[2] === 2019 || selectYear[2] === null"
                  >
                    <tr>
                      <td>금호건설</td>
                      <td>인천검단 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>위례포레자이 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>경산하양 지하주차장/옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>상아2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>다산진건 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>다산지금 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>과천주공6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>부산온천2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>일산식사3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>부천송내1-2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>구리수택 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>세종4-2M4BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>다산지금 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>서희건설</td>
                      <td>남양주부평 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>한신공영</td>
                      <td>세종4-2P1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>영무건설</td>
                      <td>광양마동 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>영무건설</td>
                      <td>대구평리 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>영무건설</td>
                      <td>시흥장현 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>아산모종 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>광주우산 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>신반포자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>김포한강메트로자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>과천주공6 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>오산대역 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>서초방배오픈발코니 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>현대ENG</td>
                      <td>위례A3-4aBL 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>청주수곡 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>성남금광3 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2019년 -->
                  <!-- 2018년 -->
                  <tbody
                    v-if="selectYear[2] === 2018 || selectYear[2] === null"
                  >
                    <tr>
                      <td>호반건설</td>
                      <td>이천마장2차 B4 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>광주계림8구역 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>아산탕정 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>가재울5 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대일산업</td>
                      <td>첨단 진아리채 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>진주혁신A6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>김포양곡B2/D1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>시흥장현 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>평택지제1BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>평택지제2BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥장현B8 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>개포시영 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>과천주공7단지 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>제일건설</td>
                      <td>시흥장현 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>울산테크노 2B-1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>울산테크노 2B-1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>인천도화 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>서초우성1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>리젠시빌건설</td>
                      <td>이천마장A2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>고덕자이6차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>리젠시빌건설</td>
                      <td>이천마장A1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>서초무지개 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>평택고덕 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>청주수곡 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>신정2-1 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>신반포자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>수원인계 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>고덕지구 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>부산명륜자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>신촌자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>고덕지구 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>안산발코니2차 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>일산킨텍스 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>구로항동 옥상조형물</td>
                      <td>오픈발코니</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>안산그랑시티자이 오픈발코니</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2018년 -->
                  <!-- 2017년 -->
                  <tbody
                    v-if="selectYear[2] === 2017 || selectYear[2] === null"
                  >
                    <tr>
                      <td>화성산업</td>
                      <td>영종화성파크드림 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>고덕지구 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>진주혁신A12 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>원주기업도시3-2BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>고덕지구 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>구미국가산단A26 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>원주기업도시3-1BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>경산임당공동1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥목감5차B9 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>신반포18,24차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>장위1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>장위5 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>리젠시빌건설</td>
                      <td>진해남문5-2BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호건설</td>
                      <td>서산테크노밸리 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>고양향동 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>구로항동 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>성남고등S2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대일산업</td>
                      <td>원주혁신도시C3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호산업</td>
                      <td>수원호매실어울림 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>포항초곡 87-2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>금호산업</td>
                      <td>동해천곡 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>전주효천 A2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>신반포센트럴자이 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>이천마장 1차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>화성산업</td>
                      <td>운정지구 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>광주센트럴 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>남양주마석푸르지오 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>동탄주상복합1차 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>수원호매실 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>중흥토건</td>
                      <td>김해진영B1 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>중흥토건</td>
                      <td>시흥목감B1 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>중흥토건</td>
                      <td>시흥배곧B2 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>중흥토건</td>
                      <td>전주만성C2 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>평택소사벌 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>용인기흥 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>송도 3차 A2 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>시흥은계 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>울산송정 옥상조형물</td>
                      <td>오픈발코니</td>
                    </tr>
                    <tr>
                      <td>백광도시개발</td>
                      <td>SK보라매 오픈발코니</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2017년 -->
                  <!-- 2016년 -->
                  <tbody
                    v-if="selectYear[2] === 2016 || selectYear[2] === null"
                  >
                    <tr>
                      <td>중흥건설</td>
                      <td>세종3-1M6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>안성용두 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>시흥은계 1,2차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>시흥배곧B2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>시흥목감B1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>삼성물산</td>
                      <td>개포2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>화성동탄A97BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>리젠시빌</td>
                      <td>양주옥정 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>고양향동1,2,3차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>오산 푸르지오 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>한류월드 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>김해율하 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>하남미사 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>이천증포 3,5BL 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>김포고천 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>안양박달 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2016년 -->
                  <!-- 2015년 -->
                  <tbody
                    v-if="selectYear[2] === 2015 || selectYear[2] === null"
                  >
                    <tr>
                      <td>호반건설</td>
                      <td>부산명지B6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>아산탕정1-A6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>오산세교D1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>아산탕정복합1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>평택소사벌 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>화성산업</td>
                      <td>대구침산 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥목감B4 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥목감B7 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>수원호매실B9 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>동문건설</td>
                      <td>천안신부 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>송도2차 RC1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>수원호매실B5 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>화성동탄A41 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>부산명지 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥배곧3차 B11 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>의정부민락1차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>인천서창 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>고양원흥 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>위례A2-2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>수원광교A6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>의정부민락2차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>의정부민락3차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>세종2-1L2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>세종2-1M2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>경북도청1차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대성건설</td>
                      <td>인천가정 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>경북도청2차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>부천옥길C1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>화성동탄A49 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>대구테크노A13 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>인천가정5 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>평택청북 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>위례C1-4 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>현대엔지니어링</td>
                      <td>위례2차 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>위례 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>성내미주 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>시흥논곡 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>세종3-3L2 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2015년 -->
                  <!-- 2014년 -->
                  <tbody
                    v-if="selectYear[2] === 2014 || selectYear[2] === null"
                  >
                    <tr>
                      <td>중흥건설</td>
                      <td>세종M1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>진아건설</td>
                      <td>대구달성 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>신금호 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>부산명지 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>대구테크노A15 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>엠코</td>
                      <td>위례신도시A3-6a 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>전북혁신C5 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>전북혁신C6 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>춘천거두 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>아산탕정A8 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>월남2-1BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>나주B15 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>전주C3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>세종3-2 M4 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>나주B14 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>평택소사벌 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대성건설</td>
                      <td>대구옥포 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥배곧B9 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>나주B10 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>송도RC4 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>중흥건설</td>
                      <td>세종 M6 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한화건설</td>
                      <td>동탄A21 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>안동센트럴자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>세종1-2 M4 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2014년 -->
                  <!-- 2013년 -->
                  <tbody
                    v-if="selectYear[2] === 2013 || selectYear[2] === null"
                  >
                    <tr>
                      <td>호반건설</td>
                      <td>울산혁신C2 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>화성동탄A22 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>안동옥동3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>시흥군자B8 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>세종시L2 1-3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>신동탄 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>시흥배곧 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>가재울 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>화성동탄A30 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>가재울 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>세종시L8 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>세종시M4 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>광주월남 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>동일토건</td>
                      <td>용곡3,4단지 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>엠코</td>
                      <td>위례신도시 A3-7블럭 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>순천오천A1 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>인천용현2BL 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>전주혁신B2 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>전주혁신B12 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>세종시M7 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>세종시M3 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>부산센텀 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한양</td>
                      <td>세종1-1 M3 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2013년 -->
                  <!-- 2012년 -->
                  <tbody
                    v-if="selectYear[2] === 2012 || selectYear[2] === null"
                  >
                    <tr>
                      <td>호반베르디움</td>
                      <td>전주혁신도시B11BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>광주제석산 호반힐하임 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>첨단2지구 A4BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>첨단2지구 A8BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>대우조선해양건설</td>
                      <td>마곡지구 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>㈜한양</td>
                      <td>첨단2지구 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>㈜한양</td>
                      <td>세종시 M3 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>㈜한양</td>
                      <td>세종시 M7 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>㈜한양,울트라건설</td>
                      <td>세곡2지구 4단지 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>전북혁신도시C7BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>세종시 M6,L2BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>공덕자이 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>해운대자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>엠코</td>
                      <td>상도엠코타운 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>한라건설</td>
                      <td>김포한강신도시 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>울산무거 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>대구신천자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>포스코건설</td>
                      <td>송도 더샾그린스퀘어 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>영등포아트자이 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2012년 -->
                  <!-- 2011년 -->
                  <tbody
                    v-if="selectYear[2] === 2011 || selectYear[2] === null"
                  >
                    <tr>
                      <td>한라건설</td>
                      <td>청주용정 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>한라건설</td>
                      <td>김포신도시 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>울산무거 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>강서자이 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>대전도안 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>금호자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>㈜한양</td>
                      <td>청라지구 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>광장동 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>㈜한양</td>
                      <td>광교신도시 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>김포신도시 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>광주첨단자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>SK건설</td>
                      <td>수원 SK Sky VIEW PC외장재</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>남양주별내 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>경남기업</td>
                      <td>김포신도시 조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2011년 -->
                  <!-- 2010년 -->
                  <tbody
                    v-if="selectYear[2] === 2010 || selectYear[2] === null"
                  >
                    <tr>
                      <td>신명종합건설</td>
                      <td>영종도 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>호반건설</td>
                      <td>김포 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>서브원</td>
                      <td>LG디스플레이 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>현대해운대 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>태영건설</td>
                      <td>태영하이원 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>연지자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>쌍용건설</td>
                      <td>김포 옥탑조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>㈜한양</td>
                      <td>파주교하 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2010년 -->
                  <!-- 2009년 -->
                  <tbody
                    v-if="selectYear[2] === 2009 || selectYear[2] === null"
                  >
                    <tr>
                      <td>대명건영</td>
                      <td>서교자이 MHS보</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>현대건설</td>
                      <td>용인성복1차 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>쌍용건설</td>
                      <td>김포신도시Ab-14BL 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>제일건설</td>
                      <td>청라 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                    <tr>
                      <td>우미건설</td>
                      <td>영종도 지하주차장</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>구성자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>성복자이1차 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>성복자이2차 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>GS건설</td>
                      <td>무학자이 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>쌍용건설</td>
                      <td>부산구서 옥상조형물</td>
                      <td>옥탑 및 옥상조형물</td>
                    </tr>
                    <tr>
                      <td>대우건설</td>
                      <td>대구 옥상조형물</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2009년 -->
                  <!-- 2008년 -->
                  <tbody
                    v-if="selectYear[2] === 2008 || selectYear[2] === null"
                  >
                    <tr>
                      <td>현대건설</td>
                      <td>인천검단3차1,2단지 지하주차장</td>
                      <td>지하주차장</td>
                    </tr>
                  </tbody>
                  <!-- //2008년 -->
                </table>
              </div>
            </div>
            <!-- 아파트 구조물 -->
            <!-- 벽식PC주택 -->
            <div
              id="feature2"
              :class="['conbox3', { active: buildCatgActArr[3] }]"
            >
              <div class="tech_slide">
                <div class="techSlide7 tech_slide01" ref="techSlide7">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_05.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_06.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_07.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_08.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_09.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
                <div class="tech-navi">
                  <div class="tech-button-prev"></div>
                  <div class="tech-button-next"></div>
                </div>
                <div class="techSlide8 tech_slide02" ref="techSlide8">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s01.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s02.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s03.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s04.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s05.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s06.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s07.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s08.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div class="swiper-slide">
                      <img
                        :data-src="`${resources}img/tech_slide04_s09.png`"
                        class="swiper-lazy"
                      />
                      <div class="swiper-lazy-preloader"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex_box mgt60">
                <h3>벽식PC주택</h3>
                <div class="selectbox3 vselect ty_wid">
                  <v-select
                    v-model="selectYear[3]"
                    :options="selectOptions[3]"
                    :searchable="false"
                    placeholder="년도"
                    :class="{ active: selectYear[3] !== null }"
                  >
                  </v-select>
                </div>
              </div>
              <!-- select 선택 시 해당 년도별 나오게 스크립트 부탁드립니다. -->
              <div class="tbl_ty01 bod align_td_cnt">
                <table>
                  <caption></caption>
                  <colgroup>
                    <col style="width: 33.33%" />
                    <col style="width: 33.33%" />
                    <col style="width: auto" />
                  </colgroup>

                  <!-- 2023년 -->
                  <tbody
                    v-if="selectYear[3] === 2023 || selectYear[3] === null"
                  >
                    <tr>
                      <td>대보건설</td>
                      <td>평택고덕</td>
                      <td>공동주택</td>
                    </tr>
                  </tbody>

                  <!-- 2019년 -->
                  <tbody
                    v-if="selectYear[3] === 2019 || selectYear[3] === null"
                  >
                    <tr>
                      <td>신동아건설</td>
                      <td>김포한강AA-12 주택</td>
                      <td>주택</td>
                    </tr>
                  </tbody>
                  <!-- //2019년 -->
                  <!-- 2018년 -->
                  <tbody
                    v-if="selectYear[3] === 2018 || selectYear[3] === null"
                  >
                    <tr>
                      <td>명관컨설팅</td>
                      <td>포일동 다세대 주택</td>
                      <td>주택</td>
                    </tr>
                    <tr>
                      <td>KCC건설</td>
                      <td>성남도촌 주택</td>
                      <td>주택</td>
                    </tr>
                  </tbody>
                  <!-- //2018년 -->
                </table>
              </div>
            </div>
            <!-- 벽식PC주택 -->
          </div>
        </t-toggle-content>
        <!--// 시공사례 -->
      </div>
      <!--// sub contents -->
    </t-toggle>
  </div>
</template>

<script>
import tech012 from './p_tech012';

export default tech012;
</script>

<style lang="scss" scoped>
.tech_slide01 {
  .swiper-wrapper .swiper-slide {
    min-height: 500px;
    background-color: #f1f1f1;
  }
}
.tech_slide02 {
  .swiper-wrapper .swiper-slide {
    min-height: 160px;
    background-color: #f1f1f1;
  }
}
</style>
